/**
 * The arena's one PRNG (mulberry32) and one string hash. `rngStep` is the pure form: it takes
 * the generator state and returns the next value with the next state, so a game that must
 * persist its randomness (the dungeon) can keep a number in its state and stay deterministic.
 */

/** One draw: `[value in [0,1), next state]`. */
export function rngStep(state: number): [number, number] {
  const next = (state + 0x6d2b79f5) >>> 0
  let t = next
  t = Math.imul(t ^ (t >>> 15), t | 1)
  t ^= t + Math.imul(t ^ (t >>> 7), t | 61)
  return [((t ^ (t >>> 14)) >>> 0) / 4294967296, next]
}

/** Small deterministic PRNG for per-game variety and reproducible tests. */
export function seededRandom(seed: number): () => number {
  let state = seed >>> 0
  return () => {
    const [value, next] = rngStep(state)
    state = next
    return value
  }
}

/** FNV-1a: a cheap, stable string → u32 seed ("code:round", "day:salt"…). */
export function hashSeed(input: string): number {
  let h = 2166136261
  for (let i = 0; i < input.length; i++) h = Math.imul(h ^ input.charCodeAt(i), 16777619)
  return h >>> 0
}
